var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"groupCategoryGrid",staticStyle:{"height":"calc(100vh - 120px)","width":"882px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }